import { useAppSelector, useNotification } from '../../store/redux/hooks'
import { RootState } from '../../store/redux/store'
import { Snackbar, Alert, SnackbarCloseReason } from '@mui/material'

export const Notification = () => {
  const notification = useAppSelector((state: RootState) => state.notification)
  const { clearNotification } = useNotification()

  const handleClose = (_: unknown, reason?: SnackbarCloseReason) => reason !== 'clickaway' && clearNotification()

  return (
    <Snackbar open={notification.open} autoHideDuration={notification.timeout} onClose={handleClose}>
      <Alert variant="filled" onClose={handleClose} severity={notification.type}>
        {notification.message}
      </Alert>
    </Snackbar>
  )
}
